import { Button, Input, message, Modal } from "antd";
import styles from "./EditItemDetails.module.css";
import { useEffect, useRef } from "react";

// Shared style for every value input (right-aligned text)
const inputBase = {
  width: "200px",
  height: 32,
  fontSize: "16px",
  textAlign: "right",
};
const inputDisabled = {
  ...inputBase,
  backgroundColor: "AppWorkspace",
  color: "black",
};

const EditItemDetails = ({
  itemDetailsOpen,
  setItemDetailsOpen,
  setItemDetailsData,
  itemDetailsData,
  itemDesignCode,
  setBarCodeData,
  barCodeData,
  qtyData,
  offerARate,
  offerBRate,
  smCodeRef,
  adminType,
}) => {
  const inputRef = useRef(null);
  const rateRef = useRef(null);
  const disPerRef = useRef(null);
  const disAmtRef = useRef(null);
  const saveRef = useRef(null);
  const handelCancel = () => {
    setItemDetailsOpen(false);
    smCodeRef.current?.focus();
  };
  useEffect(() => {
    if (itemDetailsOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [itemDetailsOpen]);

  const handleKeyDown = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextRef?.current) {
        nextRef.current.focus();
      }
    }
  };
  const maxQty1 =
    qtyData?.find((q) => q.DesignCode === itemDetailsData?.DesignCode)?.Qty ??
    0;
  return (
    <Modal
      title={
        <strong
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "16px",
            fontWeight: "bold",
            background: "#114a3d",
            borderRadius: "8px",
            padding: "4px 8px",
            color: "white",
          }}
        >
          Product Details
        </strong>
      }
      open={itemDetailsOpen}
      onCancel={handelCancel}
      closable={false}
      onOk={handelCancel}
      footer={null}
      maskStyle={{
        backdropFilter: "blur(8px)",
        backgroundColor: "rgba(0, 0, 0, 0.2)",
      }}
      afterOpenChange={(open) => {
        if (open && inputRef.current) {
          inputRef.current.focus();
        }
      }}
    >
      <div className={styles.cardContainer2}>
        <div className={styles.infoBox2}>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Design Code</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Total Wt"
                style={{
                  ...inputDisabled,
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
                disabled
                value={itemDetailsData?.DesignCode}
              />
            </span>
          </div>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Product Name</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Total Wt"
                style={inputDisabled}
                disabled
                value={itemDetailsData?.ProdName}
              />
            </span>
          </div>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Qty</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Qty"
                ref={inputRef}
                style={{
                  ...inputBase,
                  fontWeight: "bold",
                }}
                value={itemDetailsData?.stock ?? ""}
                onFocus={(e) => e.target.select()}
                onChange={(e) => {
                  const val = e.target.value;

                  if (!/^\d*\.?\d{0,2}$/.test(val)) return;

                  const qty = Number(val);

                  // 🔍 Calculate total existing stock for this DesignCode
                  const totalExistingStock = barCodeData
                    .filter(
                      (item) => item.DesignCode === itemDetailsData?.DesignCode,
                    )
                    .reduce((sum, item) => sum + Number(item.stock || 0), 0);

                  // 👉 subtract current editing row stock
                  const currentRowStock = Number(
                    barCodeData[itemDesignCode]?.stock || 0,
                  );

                  const adjustedTotal = totalExistingStock - currentRowStock;

                  // ❌ Prevent exceeding maxQty1
                  if (qty + adjustedTotal > maxQty1) {
                    message.error(
                      `Qty limit reached for ${itemDetailsData?.DesignCode}`,
                    );
                    return;
                  }

                  // ===============================
                  // SMODEL A
                  // ===============================
                  if (itemDetailsData?.SMODEL === "A") {
                    const maxOfferQty = 3;
                    if (qty > maxOfferQty) return;

                    const rate = Number(offerARate) || 0;

                    const oQty =
                      qty === 2
                        ? itemDetailsData?.OQTY2
                        : itemDetailsData?.OQTY3;

                    const rateValue = qty > 0 ? (oQty || 0) / qty : 0;

                    const price = qty === 1 ? rate : rateValue;

                    setBarCodeData((prev) =>
                      prev.map((item, index) =>
                        index === itemDesignCode
                          ? {
                            ...item,
                            stock: qty,
                            CPrice: price,
                            offer: price,
                          }
                          : item,
                      ),
                    );

                    setItemDetailsData((prev) => ({
                      ...prev,
                      stock: qty,
                      CPrice: price,
                      offer: price,
                    }));
                  }

                  // ===============================
                  // SMODEL B
                  // ===============================
                  else if (itemDetailsData?.SMODEL === "B") {
                    const maxQty = 3;
                    if (qty > maxQty) return;

                    const rateValue = Number(itemDetailsData?.CPrice) || 0;
                    const rate = Number(offerBRate) || 0;

                    const oQty =
                      qty === 2
                        ? itemDetailsData?.OQTY2
                        : itemDetailsData?.OQTY3;

                    const disPer = qty === 1 ? rate : oQty || 0;
                    const disAmt = (rateValue * disPer) / 100;
                    const actRate = rateValue - disAmt;

                    setBarCodeData((prev) =>
                      prev.map((item, index) =>
                        index === itemDesignCode
                          ? {
                            ...item,
                            stock: qty,
                            Disper: disPer,
                            Disamt: disAmt,
                            CPrice: rateValue,
                            offer: actRate,
                          }
                          : item,
                      ),
                    );

                    setItemDetailsData((prev) => ({
                      ...prev,
                      stock: qty,
                      Disper: disPer,
                      Disamt: disAmt,
                      CPrice: rateValue,
                      offer: actRate,
                    }));
                  }

                  // ===============================
                  // NORMAL MODEL
                  // ===============================
                  else {
                    setBarCodeData((prev) =>
                      prev.map((item, index) =>
                        index === itemDesignCode
                          ? { ...item, stock: qty }
                          : item,
                      ),
                    );

                    setItemDetailsData((prev) => ({
                      ...prev,
                      stock: qty,
                    }));
                  }
                }}
                onKeyDown={(e) => {
                  if (
                    itemDetailsData?.SMODEL === "A" ||
                    itemDetailsData?.SMODEL === "B"
                  ) {
                    handleKeyDown(e, saveRef);
                  } else {
                    handleKeyDown(e, rateRef);
                  }
                }}
              />
            </span>
          </div>

          {/* RATE */}
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Rate</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Rate"
                style={inputDisabled}
                disabled={
                  itemDetailsData?.SMODEL === "A" ||
                  itemDetailsData?.SMODEL === "B" ||
                  adminType !== "ADMIN"
                }
                ref={rateRef}
                value={itemDetailsData?.CPrice ?? 0}
                onFocus={(e) => e.target.select()} // Select entire value
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*\.?\d{0,2}$/.test(val)) {
                    const disPer = itemDetailsData?.Disper;
                    const rateValue = val * disPer;
                    const disAmt = rateValue / 100;
                    const ActRate = val - disAmt;

                    setBarCodeData((prev) =>
                      prev.map((item, index) =>
                        index === itemDesignCode
                          ? {
                            ...item,
                            CPrice: val,
                            Disamt: disAmt,
                            offer: ActRate,
                          }
                          : item,
                      ),
                    );
                    setItemDetailsData((prev) => ({
                      ...prev,
                      CPrice: val,
                      Disamt: disAmt,
                      offer: ActRate,
                    }));
                  }
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e, disPerRef);
                }}
              />
            </span>
          </div>

          {/* DIS PER */}
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Dis Per(%)</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Dis Per"
                style={inputDisabled}
                disabled={
                  itemDetailsData?.SMODEL === "A" ||
                  itemDetailsData?.SMODEL === "B" ||
                  adminType !== "ADMIN"
                }
                ref={disPerRef}
                value={itemDetailsData?.Disper ?? 0}
                onFocus={(e) => e.target.select()} // Select entire value
                onChange={(e) => {
                  const val = e.target.value;
                  if (!/^\d*\.?\d*$/.test(val)) return;
                  const updatedValue = val === 0 ? 0 : Number(val);
                  const rate = itemDetailsData?.CPrice;
                  const rateValue = rate * val;
                  const disAmt = rateValue / 100;
                  const ActRate = rate - disAmt;

                  setBarCodeData((prev) =>
                    prev.map((item, index) =>
                      index === itemDesignCode
                        ? {
                          ...item,
                          Disper: updatedValue,
                          Disamt: disAmt,
                          offer: ActRate,
                        }
                        : item,
                    ),
                  );
                  setItemDetailsData((prev) => ({
                    ...prev,
                    Disper: updatedValue,
                    Disamt: disAmt,
                    offer: ActRate,
                  }));
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e, disAmtRef);
                }}
              />
            </span>
          </div>

          {/* DIS AMT */}
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Dis Amt</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Dis Amt"
                style={inputDisabled}
                disabled={
                  itemDetailsData?.SMODEL === "A" ||
                  itemDetailsData?.SMODEL === "B" ||
                  adminType !== "ADMIN"
                }
                ref={disAmtRef}
                value={itemDetailsData?.Disamt ?? 0}
                onFocus={(e) => e.target.select()} // Select entire value
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*\.?\d{0,2}$/.test(val)) {
                    const rate = itemDetailsData?.CPrice;
                    const ActRate = rate - val;

                    setBarCodeData((prev) =>
                      prev.map((item, index) =>
                        index === itemDesignCode
                          ? { ...item, Disamt: val, offer: ActRate }
                          : item,
                      ),
                    );
                    setItemDetailsData((prev) => ({
                      ...prev,
                      Disamt: val,
                      offer: ActRate,
                    }));
                  }
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e, saveRef);
                }}
              />
            </span>
          </div>

          {/* ACT RATE */}
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Act Rate</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Total Wt"
                style={inputDisabled}
                disabled
                value={Number(itemDetailsData?.offer)?.toFixed(2)}
              />
            </span>
          </div>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Amount</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Total Wt"
                style={inputDisabled}
                disabled
                value={Number(
                  itemDetailsData?.stock * itemDetailsData?.offer,
                )?.toFixed(2)}
              />
            </span>
          </div>
        </div>
      </div>
      <div
        style={{
          textAlign: "right",
          marginTop: 10,
          display: "flex",
          justifyContent: "right",
          gap: "10px",
        }}
      >
        <Button
          type="primary"
          ref={saveRef}
          onClick={() => {
            handelCancel();
          }}
          style={{
            width: 100,
            backgroundColor: "#006400",
            borderRadius: "8px",
          }}
        >
          Save
        </Button>
      </div>
      {itemDetailsData?.SMODEL === "A" ? (
        <div
          style={{
            textAlign: "center",
            marginTop: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: "8px",
            background: "#003161",
            padding: "5px",
            color: "#fff",
            gap: "2px",
          }}
        >
          <span>BUY QTY : 1 @ {offerARate}/-</span>
          <span>BUY QTY : 2 @ {itemDetailsData?.OQTY2}/-</span>
          <span>BUY QTY : 3 @ {itemDetailsData?.OQTY3}/-</span>
        </div>
      ) : itemDetailsData?.SMODEL === "B" ? (
        <div
          style={{
            textAlign: "center",
            marginTop: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: "8px",
            background: "#003161",
            padding: "5px",
            color: "#fff",
            gap: "2px",
          }}
        >
          <span>BUY QTY : 1 @ {offerBRate}%</span>
          <span>BUY QTY : 2 @ {itemDetailsData?.OQTY2}%</span>
          <span>BUY QTY : 3 @ {itemDetailsData?.OQTY3}%</span>
        </div>
      ) : (
        ""
      )}
    </Modal>
  );
};
export default EditItemDetails;